const initialState = {
  protocolTypes: null,
  applicantTypes: null,
}

export default initialState;
